import React, { useMemo, useEffect } from 'react';
import { Button, LoadingData } from '@hwm/ui-lib';
import { useSidebar } from '@shared/hooks';
import { CustomHeader } from '../CustomHeader';
import { SidebarKeys, useSidebarContent } from './Sidebar.utils';
import { useSitesDataSource } from './SiteList/sitesDataSource';
import { useSiteListState } from './SiteList/useSiteListFiltersState';

export const Sidebar: React.FC = () => {
  const { sidebarData } = useSidebarContent();

  const {
    showSidebarData,
    sidebar: { section },
    handleSidebarSection,
  } = useSidebar();

  const { setSearchFilter } = useSiteListState();
  const { handleSetEmptySitesData, loading } = useSitesDataSource();

  const content = useMemo(() => {
    return sidebarData[section];
  }, [sidebarData, section]);

  const sitesOrAccountsSection = useMemo(
    () => section === SidebarKeys.accounts || section === SidebarKeys.siteList,
    [section]
  );

  // set Ids to [] - fix problem with duplicated sites
  // redux sometimes holds siteIds from different account
  useEffect(() => {
    if (section === SidebarKeys.accounts) {
      handleSetEmptySitesData();
      setSearchFilter('');
    }
  }, [section, setSearchFilter, handleSetEmptySitesData]);

  return (
    <div className="flex flex-col justify-start w-full h-full max-h-full max-w-full overflow-hidden pb-0.5">
      <CustomHeader
        title={content.header}
        buttons={[
          ...(sitesOrAccountsSection
            ? [
                <Button
                  variant={section === SidebarKeys.siteList ? 'contained' : 'outlined'}
                  onClick={() => handleSidebarSection(SidebarKeys.siteList)}
                  style={{}}
                  disabled={loading}
                >
                  Site List
                </Button>,
                <Button
                  variant={section === SidebarKeys.accounts ? 'contained' : 'outlined'}
                  onClick={() => handleSidebarSection(SidebarKeys.accounts)}
                  style={{}}
                  disabled={loading}
                >
                  Accounts
                </Button>,
              ]
            : [
                <Button variant="outlined" onClick={() => handleSidebarSection(SidebarKeys.siteList)} style={{}}>
                  Back to Site List
                </Button>,
              ]),
        ]}
        showSidebarIcon
      />
      {showSidebarData && sidebarData ? content.component : <LoadingData />}
    </div>
  );
};
